import { createApp } from "vue";

import "./styles/styles.scss";
import "bootstrap";

import App from "./App.vue";
import router from "./router";

createApp(App).use(router).mount("#app");
